import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Image from '../../elements/Image';
import LogoImageSrc from './../../../assets/images/theunderground.png';

const propTypes = {
  className: PropTypes.string
}

const Logo = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'brand',
    className
  );

  return (
    <div
      {...props}
      className={classes}
    >
      <h1 className="m-0">
        <Link to="/">
          <Image
            src={LogoImageSrc}
            alt="Logo"
            width={128}
            height={128} />
        </Link>
      </h1>
    </div>
  );
}

Logo.propTypes = propTypes;

export default Logo;